import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import Loading from 'components/dumb/loading/Loading'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'

import CompleteReimbursement from '../components/CompleteReimbursement'
import PendingReimbursement from '../components/PendingReimbursement'
import { queryReimburseReports } from 'services/api/modules/claim/approval-center/report'
import DownloadedReimbursement from '../components/DownloadedReimbursement'

const ReimbursementOverview = ({ initialTab }) => {
  // change state from child to parent
  const [tabIndex, setTabIndex] = useState(null)

  // useEffect
  useEffect(() => {
    changeRoute(tabIndex)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex])

  // function to change route based on tabIndex
  const navigate = useNavigate()

  const changeRoute = (index) => {
    switch (index) {
      case 0:
        navigate('/app/approval-center/reimbursement/pending')
        break
      case 1:
        navigate('/app/approval-center/reimbursement/downloaded')
        break
      case 2:
        navigate('/app/approval-center/reimbursement/reimbursed')
        break
      default:
        break
    }
  }

  // reimburse pending
  const {
    isLoading: pendingIsLoading,
    data: pendingRequest,
    error: pendingError,
  } = useQuery('reimbursePending', async () => {
    const { data } = await queryReimburseReports('pending reimbursement')
    return data?.reports
  })

  // reimburse downloaded
  const {
    isLoading: downloadedIsLoading,
    data: downloadedRequest,
    error: downloadedError,
  } = useQuery('reimburseDownloaded', async () => {
    const { data } = await queryReimburseReports('pending bank decision')
    return data?.reports
  })

  // reimburse complete
  const {
    isLoading: completeIsLoading,
    data: completeRequest,
    error: completeError,
  } = useQuery('reimburseComplete', async () => {
    const { data } = await queryReimburseReports('reimbursement complete')
    return data?.reports
  })

  const allLoading = () => {
    return [pendingIsLoading, completeIsLoading, downloadedIsLoading].some((item) => item === true)
  }
  return (
    <DashboardContainer headerTitle="Claim Reimbursement">
      {allLoading() ? (
        <Loading show />
      ) : (
        <Box
          sx={{
            bgcolor: 'white.main',
            border: 1,
            borderColor: 'gray-line.main',
            borderRadius: '4.5px',
          }}
        >
          <AdxTabsBadge
            scrollButtons={false}
            sxPanel={{
              bgcolor: 'transparent',
              borderRadius: 0,
              overflowY: 'unset',
              boxSizing: 'border-box',
            }}
            setTabIndex={setTabIndex}
            initialValue={initialTab}
          >
            <AdxTabsPanel label="Pending Approval">
              <PendingReimbursement reimburseData={pendingRequest} error={pendingError} />
            </AdxTabsPanel>
            <AdxTabsPanel label="Pending Reimbursement">
              <DownloadedReimbursement reimburseData={downloadedRequest} error={downloadedError} />
            </AdxTabsPanel>
            <AdxTabsPanel label="Reimbursed">
              <CompleteReimbursement reimburseData={completeRequest} error={completeError} />
            </AdxTabsPanel>
          </AdxTabsBadge>
        </Box>
      )}
    </DashboardContainer>
  )
}

export default ReimbursementOverview
